<div class="nav">

    <!-- Tabs list -->
    <ul>
        <ng-container *ngFor="let tab of tabs">
            <li [ngClass]="{ 'active' : url==tab.url ,'sub-menu' : 'true', 'mofc-graph' : (tab.name == 'As Marketed - MOFC by Pig' || tab.name == 'Optimized - MOFC by pig'  || tab.name == 'Population Average MOFC by Weight' || tab.name == 'Population Average MOFC vs Optimal' )}"
                (click)="navigate(tab)">
                <a href="javascript:void(0)">{{ tab.name | translate }}</a>
            </li>
        </ng-container>
    </ul>

    <!-- Bar -->
    <div class="bar"></div>

    <!-- Module wise action -->
    <ng-container *ngIf="action">
        <ng-container [ngSwitch]="module">

        </ng-container>
    </ng-container>


</div>